import { FC } from 'react';
import { Button, Typography } from '@mui/joy';
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';
import { useTranslation } from 'react-i18next';
import { NotificationItem } from '@consolidocs-ui/utils';
import { NotificationRow } from './NotificationRow';

type NotificationPanelProps = {
  notifications: NotificationItem[];
  onDismiss: (id: string) => void;
  onClearAll: () => void;
};

export const NotificationPanel: FC<NotificationPanelProps> = ({
  notifications,
  onDismiss,
  onClearAll,
}) => {
  const { t } = useTranslation();
  const isEmpty = notifications.length === 0;

  return (
    <div className="notification-panel">
      <header className="notification-panel__header">
        <Typography level="title-sm">{t('Notifications')}</Typography>
        {!isEmpty && (
          <Button
            size="sm"
            variant="plain"
            color="neutral"
            onClick={onClearAll}
          >
            {t('Clear all')}
          </Button>
        )}
      </header>

      {isEmpty ? (
        <div className="notification-panel__empty">
          <NotificationsNoneRoundedIcon />
          <Typography level="body-sm">{t('No notifications yet')}</Typography>
        </div>
      ) : (
        <ul className="notification-panel__list">
          {notifications.map((notification) => (
            <NotificationRow
              key={notification.id}
              notification={notification}
              onDismiss={onDismiss}
            />
          ))}
        </ul>
      )}
    </div>
  );
};
